export * from './ProductHighlights';
export * from './ContentfulProductHighlights';
export * from './content';
